"use client";

import { CalendarTodayResponse } from "@/lib/api";
import { formatDateLong } from "./types";
import Badge from "@ishvaram/ui/Badge";

interface CalendarTodayCardProps {
  data: CalendarTodayResponse;
}

export function CalendarTodayCard({ data }: CalendarTodayCardProps) {
  const allEvents = [...data.festivals, ...data.vrats, ...data.eclipses, ...data.tithi_events];

  return (
    <div className="bg-gradient-to-br from-ish-accent-light/30 to-ish-accent-light/10 border border-ish-accent/20 rounded-xl p-5 mb-6 shadow-sm">
      <div className="flex items-center gap-2.5 mb-3">
        <div className="w-2 h-2 rounded-full bg-ish-accent shrink-0" />
        <h2 className="font-serif text-lg font-bold text-ish-dark m-0">
          Today&apos;s Significance
        </h2>
        <span className="text-sm text-ish-text-muted">{formatDateLong(data.date)}</span>
      </div>

      {allEvents.length === 0 ? (
        <p className="text-sm text-ish-text-muted m-0">
          No special observances today. Check the monthly calendar below for upcoming festivals.
        </p>
      ) : (
        <div className="flex flex-col gap-2">
          {allEvents.map((event) => (
            <div
              key={event.id}
              className="flex items-center gap-2.5 p-2 px-3 bg-white/60 rounded-lg border border-ish-border/10"
            >
              <Badge
                label={event.type.charAt(0).toUpperCase() + event.type.slice(1)}
                variant={
                  event.type === "vrat"
                    ? "success"
                    : event.type === "festival"
                      ? "warning"
                      : "accent"
                }
              />
              <div className="flex-1 min-w-0">
                <span className="font-semibold text-sm text-ish-dark">{event.name_en}</span>
                <span className="text-sm text-ish-text-muted ml-1.5">{event.name_hi}</span>
              </div>
              {event.fasting && <Badge label="Fasting" variant="error" />}
            </div>
          ))}
        </div>
      )}

      {data.is_fasting_day && (
        <div className="mt-3 p-2 px-3 bg-red-50 rounded-lg text-sm text-red-600 font-medium border border-red-100">
          Today is a fasting day. Avoid grains, beans, and non-vegetarian food if observing the
          vrat.
        </div>
      )}
    </div>
  );
}
